module.exports = __webpack_public_path__ + "img/done.b94929c8.png";